import {DOCUMENT,isPlatformBrowser} from '@angular/common';
import {InjectionToken,PLATFORM_ID,inject} from '@angular/core';
import {loadScript} from '../load-script';
import {ConsentService} from '../consent/consent.service';

export interface XWidgets{widgets:{load:(element?:Element)=>void}}

const WIDGETS_SRC='https://platform.twitter.com/widgets.js';

export const X_WIDGETS=new InjectionToken<()=>Promise<XWidgets|null>>('x.widgets',{
	providedIn:'root',
	factory:()=>{
		const isBrowser=isPlatformBrowser(inject(PLATFORM_ID));
		const document=inject(DOCUMENT);
		const consent=inject(ConsentService);
		let pending:Promise<XWidgets|null>|null=null;
		return ():Promise<XWidgets|null>=>{
			if(!isBrowser||!consent.marketing()){
				return Promise.resolve(null);
			}
			pending??=loadScript(document,WIDGETS_SRC).then(()=>document.defaultView?.twttr ?? null);
			return pending;
		};
	}
});
